import { CommonModule } from '@angular/common';
import { AfterViewChecked, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CamelCasePipe } from '../../utils/camel-case.pipe';
import { DataTableSchema, DefaultTableSchema, TITLE_TYPE } from '../../model/dynamic-data-table.model';
import { DynamicDataTableComponent } from '../../layout/dynamic-data-table/dynamic-data-table.component';
import { ApiEnvNames, ExportConfig, SearchConfig } from '../../model/api.model';
import { chatbotChartConfig, chatBotSearchConfig, MessagesType } from '../../model/chat-bot.model';
import { CommonService } from '../../services/common.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CHART_TYPE, PieChartModel } from '../../model/chart.model';
import { ChartComponent } from '../../layout/chart/chart.component';
import { EXCEL_EXTENSION } from '../../services/excel-export.service';
import { FileDownloadSearchConfig } from '../../model/common.model';
import { CommonUtils } from '../../utils/common.utils';

@Component({
  selector: 'app-chat-bot',
  standalone: true,
  imports: [FormsModule, MatDialogModule, MatIconModule, CommonModule, CamelCasePipe, DynamicDataTableComponent,MatTableModule, ChartComponent],
  templateUrl: './chat-bot.component.html',
  styleUrls: ['./chat-bot.component.scss'],
})
export class ChatBotComponent implements OnInit, AfterViewChecked {

  @ViewChild('dialogContent') dialogContent!: ElementRef;

  private readonly service = inject(CommonService);
  private readonly commonUtils = inject(CommonUtils);

  private shouldScroll = false;
  private readonly sessionId = 'session-' + Date.now();
  public question = '';
  public chatLoader = false;
  public messages: MessagesType[] = [];

  qaDatabase: {
    question: string;
    answer: string;
    type?: 'text' | 'table' | 'chart'; 
    suggestedQns?: number[];
  }[] = [
    // { question: 'How much was the recovery for LXIV-PD02 course last month?', answer: '$32,375.00', type: 'text', suggestedQns: [1, 3] },
    // { question: 'Top 3 courses that has maximum recoveries this year', answer: 'LXIV-PD02\nLXIV-SL001\nLXIV-PD05', type: 'text', suggestedQns: [2, 5, 6] },
    // { question: 'Create a recovery comparison chart for the course LXIV-PD02 across months?', answer: '', type: 'chart' },
    // { question: 'Attendance count for LXIV-PD02 course for the past 3 months', answer: 'May: Completed - 189, No Show - 40\nJune: Completed - 356, No Show - 79\nJuly: Completed - 140, No Show - 45', type: 'table' },
    // { question: 'Hiring trend for Service Technicians', answer: 'Steady growth from January till April. Slight dip in June and July due to seasonal effect.', type: 'text' },
    // { question: 'Generate a recovery trend chart for the top 3 course?', answer: '', type: 'chart' },
    // { question: 'List 3 lowest recoveries courses', answer: '', type: 'text' }
    { question: 'information CBL', answer: '$32,375.00', type: 'text', suggestedQns: [1, 3] },
    { question: 'How many Service Consultants are in the Central Area?', answer: 'LXIV-PD02\nLXIV-SL001\nLXIV-PD05', type: 'text', suggestedQns: [2, 5, 6] },
    { question: 'Download the JobRoleSummary Report', answer: '', type: 'chart' },
    { question: 'display area billing trends for 2025', answer: 'May: Completed - 189, No Show - 40\nJune: Completed - 356, No Show - 79\nJuly: Completed - 140, No Show - 45', type: 'table' },
    { question: 'Give me the job role summary report', answer: 'Steady growth from January till April. Slight dip in June and July due to seasonal effect.', type: 'text' },
    { question: 'How many Master Certified Sales Consultants are enrolled in LML?', answer: '', type: 'chart' },
    { question: 'How many Service Consultants are in the Southern Area ?', answer: '', type: 'text' },
    { question: 'Fetch job summary report', answer: '$32,375.00', type: 'text', suggestedQns: [1, 3] },
    { question: 'How many unique associates in lexus', answer: 'LXIV-PD02\nLXIV-SL001\nLXIV-PD05', type: 'text', suggestedQns: [2, 5, 6] },
    { question: 'How many associates count in lexus', answer: '', type: 'chart' },
    { question: 'How much has Dealer Code XXXXXX been paid this calendar year for LML?', answer: 'May: Completed - 189, No Show - 40\nJune: Completed - 356, No Show - 79\nJuly: Completed - 140, No Show - 45', type: 'table' },
    { question: 'How many RZs are currently leased by Dealer Associates who are actively paid in LML?', answer: 'Steady growth from January till April. Slight dip in June and July due to seasonal effect.', type: 'text' },
    { question: 'How many RZs are currently leased by Dealer Associates?', answer: '', type: 'chart' },
    { question: 'How many Dealer Associates who are participating in LML have a lease that will mature in 2026?', answer: '', type: 'text' }
  ];

  ngOnInit() {
    this.messages.push({
      question: '', answer: 'Hello How can i assist you!',
      showSuggestion: false,
      suggestedQuestions: []
    })
  }

  ngAfterViewChecked() {
    if (this.shouldScroll) {
      const element = this.dialogContent?.nativeElement;
      if (element) {
        element.scrollTop = element.scrollHeight;
      }
      this.shouldScroll = false;
    }
  }

  async fetchBotResponse(question: string): Promise<string> {
    const searchConfig: SearchConfig = structuredClone(chatBotSearchConfig);
    searchConfig['body'] = { message: question, sessionId: this.sessionId };
    try {
      const response:any = await this.service.getDataFromDataSource(searchConfig, ApiEnvNames['ChatBot']);
      if(response.result?.messages[0]?.content){
        return response.result?.messages[0];
      }
      return 'No response';
    } catch (error) {
      console.info('ChatBot API failed', {error,question,sessionId: this.sessionId});
      return 'Please try again after some time';
    }
  }

  async submitQuestion() {  
    if (!this.question.trim()) {return};

    const userQuestion = this.question.trim();
    this.messages.push({
      question: userQuestion,
      answer: '',
      showSuggestion: false,
      suggestedQuestions: []
    });
    this.question = '';
    this.chatLoader = true;
    this.shouldScroll = true;

    this.messages.forEach(m => { m.showSuggestion = false; m.suggestedQuestions = [] });

    try {
      const response: any = await this.fetchBotResponse(userQuestion);

      if(!response){
        const lastMessage = this.messages.at(-1);
        if (lastMessage) {
          lastMessage.answer = `Sorry, I don't have an answer for "${userQuestion}".`;
          lastMessage.showSuggestion = false;
        }
        return;
      }
      
      let data = response['content'];
      let type = response['contentType']
      if(type === 'CustomPayload'){
        const dataResponse = JSON.parse(data)
        type = dataResponse.type;
        data = dataResponse.data;
        if (type === "table") {
          this.handleTableResponse(data);
        }else if(type === "download"){
          this.handleDownloadResponse(data);
        } else if(type === "chart"){
          this.handleChartResponse(data, dataResponse);
        }
      } else {
        const lastMessage = this.messages.at(-1);
        if (lastMessage) {
          lastMessage.answer = data ?? `Sorry, I don't have an answer for "${userQuestion}"`;
          lastMessage.type = 'text';
        }
      }

      const matchedQA = this.qaDatabase.find(qa => qa.question.toLowerCase() === userQuestion.toLowerCase());
      let suggestions: string[] = [];
      if (matchedQA?.suggestedQns) {
        suggestions = matchedQA.suggestedQns.slice(0, 3).map(index => this.qaDatabase[index]?.question).filter(Boolean);
      }
      if (suggestions.length < 3) {
        const availableQuestions = this.qaDatabase.map(qa => qa.question).filter(q => !suggestions.includes(q));
        while (suggestions.length < 3 && availableQuestions.length > 0) {
          const randomIndex = this.commonUtils.getSecureRandomNumber(availableQuestions.length);
          suggestions.push(availableQuestions.splice(randomIndex, 1)[0]);
        }
      }
      if (suggestions.length > 0) {
        const lastMessage = this.messages.at(-1);
        if (lastMessage) {
          lastMessage.showSuggestion = true;
          lastMessage.suggestedQuestions = suggestions.slice(0, 3);
        }
      }
    } catch (error) {
      console.info(error);
      const lastMessage = this.messages.at(-1);
      if (lastMessage) {
        lastMessage.answer = `Sorry, I don't have an answer for "${userQuestion}".`;
        lastMessage.showSuggestion = false;
      }
    } finally {
      const lastMessage = this.messages.at(-1);
      if (!lastMessage?.showSuggestion) {
        const availableQuestions = this.qaDatabase.map(qa => qa.question);
        const suggestions: string[] = [];
        while (suggestions.length < 3 && availableQuestions.length > 0) {
          const randomIndex = this.commonUtils.getSecureRandomNumber(availableQuestions.length);
          suggestions.push(availableQuestions.splice(randomIndex, 1)[0]);
        }
        if (suggestions.length > 0) {
          if (lastMessage) {
            lastMessage.showSuggestion = true;
            lastMessage.suggestedQuestions = suggestions.slice(0, 3);
          }
        }
      }
      this.chatLoader = false;
      this.shouldScroll = true;
    }
  }

  downloadFile(file: any) {
    const exportConfig: ExportConfig = {
      environment: ApiEnvNames['StaffMaster'],
      fileExtension: EXCEL_EXTENSION,
      searchParameters: FileDownloadSearchConfig,
      exportFileName: 'chatBotExport',
      tableSchema: undefined
    };
    if (file) {
      this.commonUtils.spinner('show');
      this.service.downloadExcelFromS3(file, exportConfig).then(() => {
        this.commonUtils.spinner('hide');
      }).catch(() => {
        this.commonUtils.spinner('hide');
      })
    }
  }
  handleDownloadResponse(data: any) {
    const lastMessage = this.messages.at(-1);
    data['fileName'] = data['key'] ?? data['fileName']
    if (lastMessage) {
      lastMessage.answer = data;
      lastMessage.type = 'download';
    }

  }
  handleChartResponse(data: any, config:any) {
    let chartConfig!:chatbotChartConfig;
    if (config['chartType'] === CHART_TYPE['PieChart']) {
      chartConfig = {
        chartSchema: {
          ...structuredClone(PieChartModel),
          tooltip: {
            headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
            pointFormat: `<span>${config['yAxis']}</span>: <b>$ {point.y}</b><br/>`
          },
          dataSchema: {
            label: config['xAxis'],
            value: config['yAxis'],
          },
          titleSchema:{
                    label: '',
                    subLabel: '',
                    title: 'Billing Trend for Year',
                    subTitle: '',
                    type: TITLE_TYPE['Static']
          }
        },
        filterSchema:{},
        chartType: CHART_TYPE['PieChart'],
        elementId: Date.now(),
        onLoadFetch: false,

      }
    }
    
    const lastMessage = this.messages.at(-1);
    if(!chartConfig){
    if (lastMessage) {
      lastMessage.answer = 'No Data Found'; 
      lastMessage.type = 'text';
    }
    return;
    }
    if (lastMessage) {
      lastMessage.answer = data;
      lastMessage.chartConfig = chartConfig;
      lastMessage.type = 'chart';
    }
  }

  handleTableResponse(dataArr: any) {
    const lastMessage:any = this.messages.at(-1);
    if(dataArr){
    const tableSchema:DataTableSchema = structuredClone(DefaultTableSchema)
    tableSchema.isSearchRequired = false
    tableSchema.isPaginationRequired = false
    tableSchema.isExportRequired = false
    const dataset = dataArr[0]
    tableSchema['columnSchema'] = Object.keys(dataset).map(headerName => ({
      label: headerName.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
      fieldKey: headerName
    }));

    if (lastMessage) {
      lastMessage.tableSchema = tableSchema;
      lastMessage.answer = new MatTableDataSource(dataArr);
      lastMessage.type = 'table';
    }
    }else{
      lastMessage.answer = 'No Data Found';
      lastMessage.type = 'text';
    }
  }

  onSuggestionClick(suggestion: string) {
    this.question = suggestion;
    this.submitQuestion();
  }
}
